const profileColors = [
  {
    title: 'Biru',
    name: 'blueGradient',
    price: 0,
    isOwned: true,
  },
  {
    title: 'Merah',
    name: 'redGradient',
    price: 25,
    isOwned: false,
  },
  {
    title: 'Oranye',
    name: 'orangeGradient',
    price: 25,
    isOwned: false,
  },
  {
    title: 'Hijau',
    name: 'greenGradient',
    price: 25,
    isOwned: false,
  },
  {
    title: 'Violet',
    name: 'violetGradient',
    price: 25,
    isOwned: false,
  },
  {
    title: 'Biru-Hijau',
    name: 'blueGreenGradient',
    price: 35,
    isOwned: false,
  },
  {
    title: 'Merah-Oranye',
    name: 'redOrangeGradient',
    price: 35,
    isOwned: false,
  },
  {
    title: 'Warna',
    name: 'allColors',
    price: 100,
    isOwned: false,
  }
]

export default profileColors